module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0127.jpg?v=683390c6";